/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum FILTER_TYPE_VALUES {
  EXPR = "expr",
  KEYS = "keys",
  NAMED = "named",
}
